module.exports = __webpack_public_path__ + "img/logo.bdc026d4.png";